// @ts-check
import User from "./models/users/user";
/**
 * @typedef {Object} Appsettings
 * @property {boolean} dev
 * @property {string} version
 * @property {string} build
 * @property {boolean} IsReady
 * @property {string} ApiUrl
 * @property {string} ApiToken
 * @property {User | null} User
 * @property {boolean} imgToDicom
 * @property {string} whatsappMessage
 * @property {number} chunkSize
 * @property {number} cinemaLoop
 */
/**
 * @type {Appsettings}
 */
export const Appsettings = {
  dev: process.env.NODE_ENV !== "production",
  version: "1.0.0",
  build: "20260221",
  IsReady: false,
  ApiUrl: "",
  ApiToken: "",
  User: null,
  imgToDicom: false,
  whatsappMessage: "/settings/wp.txt",
  chunkSize: 10,
  cinemaLoop: 10,
};

/**
 * @typedef {Object} DealerInfo
 * @property {string} name
 * @property {string} address
 * @property {string} phone
 * @property {string} website
 */
/**
 * @type {DealerInfo}
 */
export const DealerInfo = {
  name: "SARAI",
  address:
    "Edificio Rodrigo Av.Bush entre primer y segundo anillo santa cruz Bolivia",
  phone: "59170866119",
  website: "",
};

/**
 * @typedef {Object} ClientSetting
 * @property {Object} Theme
 * @property {string} Theme.primary
 * @property {string} Theme.primaryForeground
 * @property {string} Theme.secondary
 * @property {string} Theme.tertiary
 * @property {string} InstitutionName
 * @property {string} DefaultCountry
 * @property {number} sharetime
 * @property {string} refNumber
 */
/**
 * @type {ClientSetting}
 */
export const ClientSetting = {
  Theme: {
    primary: "#2c8547",
    primaryForeground: "white",
    secondary: "#22252a",
    tertiary: "#ee8c39",
  },
  InstitutionName: "SARAI",
  DefaultCountry: "591",
  sharetime: 48,
  refNumber: "",
};

/**
 * @typedef {Object} ContriCode
 * @property {string} name
 * @property {string} code
 */
/**
 * @type {ContriCode[]}
 */
export const ContriCodesList = [];

/**
 * @typedef {Object} WindowLevel
 * @property {number} wc - Window Center
 * @property {number} ww - Window Width
 */

/**
 * @typedef {Object.<string, Object.<string, WindowLevel>>} MedicalPresetMap
 */

/** @type {MedicalPresetMap} */
export const MedicalPreset = {
  CT: {
    SOFT_TISSUE: { wc: 40, ww: 400 },
    LUNG: { wc: -600, ww: 1500 },
    BONE: { wc: 480, ww: 2500 },
    BRAIN: { wc: 40, ww: 80 },
  },
};
